<template>
  <div>
    <b-card title="Ministerio de Salud">
      <b-card-text>Estadística Vectores</b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText, BLink } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BLink,
  },
}
</script>

<style>

</style>
